import { useState } from 'react';
import { accessJsonAttr, cleanUpSpecialChars, formatNumeroSecu } from '../../utils/utils';
import MgpIcon from '../MgpIcon/MgpIcon';
import { MgpInputProps } from './MgpInput.types';
import MgpTooltip from '../MgpTooltip/MgpTooltip';


export default function MgpFormInput({id, label, labelFontWeight, required, icon, iconPosition, iconColor, register, errors, tooltipPosition, disabled, handleClickInfo, tooltipText, isBoderShort, mgpTooltipText, ...props }: MgpInputProps)  {

    const [value, setValue] = useState(props.value);
    const [inputType, setInputType] = useState(props.type);

    let labelClassName = "text fw-" + (labelFontWeight ?? "medium");
    
    let inputClassName = "form-control";
    
    let fieldError;
    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
            inputClassName += " form-error";
            labelClassName += " form-error";
        }
    }
 
    if(props.type === 'file') {
        inputClassName += " file-upload-field";
    }

    if(props.className) {
        inputClassName += " " + props.className;
    }

    const iconClick = (e: any) => {
        if(inputType === 'password') {
            setInputType('text');
        } else if(inputType === 'text' && props.type === 'password') {
            setInputType('password');
        }
    }

    const onChangeEvent = (e: any) => {

            if(props.autoCapitalize ==='characters' && props.autospace) {
                const target = e.currentTarget;
                const originalValue = target.value;
                const originalPosition = target.selectionEnd;
                
                const charsBeforeCursor = originalValue.substring(0, originalPosition).replace(/\s/g, '').length;

                const regexSpace = new RegExp("(.{"+ props.autospace + "})", "g");
                const formattedValue = originalValue
                                    .replace(/\s/g, '')
                                    .replace(regexSpace, '$1 ')
                                    .trim()
                                    .toUpperCase();
                const spacesToAdd = Math.floor(Math.max(0, charsBeforeCursor - 1) / props.autospace);
                const newPosition = charsBeforeCursor + spacesToAdd;
 
                target.value = formattedValue;
                target.selectionStart = target.selectionEnd = newPosition;
                setValue(target.value);
            } else if(props.autoCapitalize ==='characters' && !props.autospace) {
                const target = e.currentTarget;
                const position = target.selectionEnd;
                const formattedValue = cleanUpSpecialChars(target.value).toUpperCase();
                setValue(formattedValue);
                setTimeout(() => {
                    target.selectionStart = target.selectionEnd = position;
                }, 0);
               
            } else if(props.autospace) {
                const regexSpace = new RegExp("(.{"+ props.autospace + "})", "g");
                let target = e.currentTarget, position = target.selectionEnd, length = target.value.length;
                target.value = target.value.replace(/\s/g, '').replace(regexSpace, '$1 ').trim();
                target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
                setValue(target.value);
            } else if (label === "N° de sécurité sociale" || label === "Numéro de sécurité sociale") {
                setValue(formatNumeroSecu(e.currentTarget.value));
            } else if(props.regex) {
                let target = e.currentTarget, position = target.selectionEnd, length = target.value.length;
                target.value = target.value.replace(/\s+/g, '').replace(props.regex[0], props.regex[1]).trim();
                target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
                setValue(target.value);
            }
            else {
                setValue(e.currentTarget.value);
            }
  
        if(props.onChange) {
            props.onChange(e);
        }

        
    }
    
    const handleKeyDown = (event: any) => {
        if (event.keyCode === 13) {
          event.preventDefault();
        }
      }; 
    
    if(disabled) {
        return (
            <>
                {label&&
                <label className={labelClassName} htmlFor={id}>
                      {label} {required ? <span className='fushia'>(*)</span>: ''}
                </label>}
                <div className='mt-md pt-md'>
                <p className='text bleu fw-medium fz-normal'>{props.value}</p>
                <span className={`border-bleu light mt-sm ${isBoderShort && "short"}`}></span>
                </div>
            </>
        );
    }

    if(icon) {
        if(!iconPosition) {
            iconPosition = "left";
        }
        let divClassName = "input-withicon-" + iconPosition;
        if(props.type === 'date' || props.type === "datetime-local") {
            divClassName = "input-date";
            iconPosition = "right";
        }

        if(props.type === 'file') {
            divClassName += " file-upload-wrapper";
        }
        
    
        return (
           <>
                {label&&<label className={labelClassName} htmlFor={id}>
                    {label}{required ? <span className='fushia'> (*)</span>: ''}
                </label>}
                <div className={divClassName} {...(props.type === 'file'&& {'data-text': props.dataText ?? 'Choisissez un fichier...'})}>
                    {iconPosition === 'left'&&<MgpIcon icon={icon} color={iconColor} onClick={iconClick}/>}
                    {register&&<input  {...props} type={inputType} className={inputClassName} id={id} onKeyDown={handleKeyDown} {...register(id, {onChange:(e) => {onChangeEvent(e)}})}  value={props.unsetValue ? '' : value} />}
                    {!register&&<input  {...props} type={inputType} className={inputClassName} id={id} onKeyDown={handleKeyDown} value={props.unsetValue ? '' : value} onChange={onChangeEvent} />}
                    {iconPosition === 'right'&&<MgpIcon icon={icon} color={iconColor} onClick={iconClick}/>}
                </div>
                {fieldError && (<p className="error">{fieldError.message}</p>)}
               
            </>
        );
    } else {
        return (
            <>
                {
                    label &&
                    <label className={labelClassName} htmlFor={id}>
                        {label} {required ? <span className='fushia'>(*)</span>: ''} {handleClickInfo &&<span onClick={handleClickInfo} className="info-badge info-button" title={tooltipText ?? "Cliquer"}>i</span>} {mgpTooltipText && mgpTooltipText.length > 0 &&  <MgpTooltip text={mgpTooltipText}  maxWidth="550px">
                             <p 
                                className='info-badge info-icon' 
                                style={{
                                    marginTop: '-14px', 
                                    height: '15px', 
                                    width: '15px',
                                    fontSize: '11px'
                                }}>i</p>
                        </MgpTooltip>}
                    </label>
                }

                {register&&<input  type={inputType} className={inputClassName} id={id} onKeyDown={handleKeyDown} {...register(id, {onChange: (e) => {onChangeEvent(e)}})} value={props.unsetValue ? '' : value} {...props}  />}
                {!register&&<input  type={inputType} className={inputClassName} id={id} onKeyDown={handleKeyDown}  value={props.unsetValue ? '' : value} onChange={onChangeEvent}  {...props} />}
                {fieldError && (<p className="error">{fieldError.message}</p>)}
            </>
        );
      }
    }

